

nn.component.FooterSection = function (element) {
  this.element = $(element);

  this.element.find('h2').on('click', function () {
    if (window.innerWidth < 480){
      $(this).parent().toggleClass('active');
    }
  });
};